import { Skeleton, Text, type TextProps, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'

import { useStoreDates } from '../../hooks/useStoreDates'
import { type ItemWithAvailability } from '../../types/ItemWithAvailability'

export type TextItemAvailabilityProps = TextProps & {
  item?: ItemWithAvailability
  isLoading?: boolean
  quantity?: number
  withinParentesis?: boolean
}

export function TextItemAvailability({
  item,
  quantity,
  isLoading,
  withinParentesis = true,
  ...props
}: TextItemAvailabilityProps) {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  const { startAt, endAt } = useStoreDates()

  if (!item) {
    return
  }

  if (isLoading) {
    return <Skeleton h={15} w={50} />
  }

  return (
    <Tooltip
      label={
        startAt && endAt
          ? t('text_item_availability.label_tooltip_with_dates')
          : t('text_item_availability.label_tooltip_without_dates')
      }
    >
      <Text style={{ flexShrink: 0, cursor: 'default' }} {...props}>
        {withinParentesis
          ? `(${t(item?.availabilityLabel)})`
          : t(item?.availabilityLabel)}
      </Text>
    </Tooltip>
  )
}
